import { useEffect, useState } from "react";
import api, { inr, formatDate, BACKEND_URL } from "@/lib/api";
import DashboardLayout from "@/components/DashboardLayout";
import { Download } from "lucide-react";

export default function DistOrders() {
  const [orders, setOrders] = useState([]);
  useEffect(() => { api.get("/orders/me").then((r) => setOrders(r.data)); }, []);

  const downloadInvoice = async (orderNo) => {
    const token = localStorage.getItem("samara_token");
    const res = await fetch(`${BACKEND_URL}/api/invoices/order/${orderNo}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `invoice-${orderNo}.pdf`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <DashboardLayout title="My Orders" subtitle={`${orders.length} order${orders.length !== 1 ? "s" : ""}`}>
      <div className="bg-white border border-border rounded-sm overflow-x-auto">
        <table className="w-full text-sm min-w-[800px]">
          <thead className="bg-navy text-white">
            <tr>
              {["Order #", "Date", "Items", "SP", "Total", "Payment", "Status", "Invoice"].map((h) => (
                <th key={h} className="text-left px-4 py-3 text-xs uppercase tracking-widest font-medium">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {orders.length === 0 && <tr><td colSpan={8} className="p-6 text-center text-navy/50">No orders yet</td></tr>}
            {orders.map((o) => (
              <tr key={o.id} data-testid={`order-${o.order_no}`} className="border-b border-border last:border-0 hover:bg-cream/40">
                <td className="px-4 py-3 text-navy font-medium">{o.order_no}</td>
                <td className="px-4 py-3 text-navy/70">{formatDate(o.created_at)}</td>
                <td className="px-4 py-3 text-navy/70">{o.items.length}</td>
                <td className="px-4 py-3 text-gold-deep">{o.total_sp}</td>
                <td className="px-4 py-3 font-semibold text-navy">{inr(o.total)}</td>
                <td className="px-4 py-3 text-navy/60 capitalize">{o.payment_mode}</td>
                <td className="px-4 py-3">
                  <span className={`text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-sm bg-olive/10 text-olive`}>{o.status}</span>
                </td>
                <td className="px-4 py-3">
                  <button data-testid={`download-invoice-${o.order_no}`} onClick={() => downloadInvoice(o.order_no)} className="inline-flex items-center gap-1 text-xs text-navy hover:text-gold">
                    <Download size={14} /> PDF
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </DashboardLayout>
  );
}
